import { EntityRepository } from "../";
import { Currency } from "../domain";

class CurrencyRepository implements EntityRepository<Currency> {
  private _repo: EntityRepository<Currency>;

  constructor(repo:EntityRepository<Currency>) {
    this._repo = repo;
  }
  checkUniqueString(attribute: (obj: Currency) => string, value: string): boolean {
    return this._repo.checkUniqueString(attribute, value);
  }

  getAll(): Currency[] {
    return this._repo.getAll();
  }
  get(uuid: string): Currency | undefined {
    return this._repo.get(uuid);
  }
  put(uuid: string, value: Currency): Promise<void> {
    return this._repo.put(uuid, value);
  }
  async putAll(values: Currency[]) {
    return this._repo.putAll(values);
  }
  delete(uuid: string): void {
    this._repo.delete(uuid);
  }
  getDefaultCurrency() : Currency {
    const currencies = this.getAll();
    if (currencies && currencies.length > 0 ) {
      return currencies.find(cur => cur.primary) || currencies[0];
    }
    throw new Error("Illegal state");
  }
}

export { CurrencyRepository };